module.exports = __webpack_public_path__ + "img/4@2x.cc2d898b.png";